<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useRealtimeStore } from '@/stores/realtime'
import { formatRelative } from '@/composables/useFormatters'

const realtime = useRealtimeStore()
const { state, lastEventAt } = storeToRefs(realtime)

const label = computed(() => {
  switch (state.value) {
    case 'open':
      return 'Živé aktualizace jsou zapnuté'
    case 'connecting':
      return 'Připojuji k živým aktualizacím…'
    case 'closed':
      return 'Živé aktualizace nejsou dostupné'
    default:
      return 'Živé aktualizace vypnuté'
  }
})

const title = computed(() =>
  lastEventAt.value ? `${label.value} · poslední událost ${formatRelative(lastEventAt.value.toISOString())}` : label.value,
)
</script>

<template>
  <span
    class="indicator"
    :class="`is-${state}`"
    :title="title"
  >
    <span
      class="indicator__dot"
      aria-hidden="true"
    />
    <span class="sr-only">{{ label }}</span>
  </span>
</template>

<style scoped>
.indicator {
  display: grid;
  place-items: center;
  width: 22px;
  height: 34px;
}

.indicator__dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--border-strong);
  transition: background var(--transition);
}

.indicator.is-open .indicator__dot {
  background: var(--success);
  /* Jemné pulzování dává najevo, že spojení opravdu žije. */
  animation: indicator-pulse 2.4s ease-in-out infinite;
}

.indicator.is-connecting .indicator__dot { background: var(--warning); }
.indicator.is-closed .indicator__dot { background: var(--danger); }

@keyframes indicator-pulse {
  0%, 100% { opacity: 1; box-shadow: 0 0 0 0 color-mix(in srgb, var(--success) 45%, transparent); }
  50% { opacity: 0.75; box-shadow: 0 0 0 4px transparent; }
}
</style>
